import { Button, Modal } from "antd";
import parse from "html-react-parser";
import React, { ReactNode } from "react";
import correct from "../../../assets/images/answer-modal-title-correct.png";
import wrong from "../../../assets/images/answer-modal-title-wrong.png";
import { Constants } from "../../../core/helpers/constants";
import FireRemoteService from "../../../core/services/fire-remote";
import AppStore from "../../../Store";
import "./answer-modal.scss";
import PrizeInfo from "./prize-info/prize-info";

interface IProps {
  appStore: AppStore;
  isVisible: boolean;
  isCorrectAnswer: boolean;
  isExtra: boolean;
  callbackOk: () => void;
  callbackCancel: () => void;
  showPaymentButton?: boolean;
}

const ModalAnswer = (props: IProps) => {

  const renderCorrect = (): ReactNode => {
    return (
      <React.Fragment>
        <div className="title-wrapper">
          <img className="icon" src={correct} alt="correct" />
          <div className="text">
            {parse(
              FireRemoteService.getStringValue(
                FireRemoteService.correct_popup_title
              )
            )}
          </div>
        </div>

        <PrizeInfo
          points={FireRemoteService.getStringValue(FireRemoteService.correct_popup_fb)}
          title={FireRemoteService.getStringValue(FireRemoteService.correct_popup_kazandin)}
        />

        {props.isExtra && (
          <PrizeInfo
            points={Constants.answerModalYaaniPrizeInfoBoxPrizeExtra2000Points}
            title={Constants.answerModalYaaniPrizeInfoBoxTitleExtra}
          />
        )}

        <div className="note">
          {parse(
            FireRemoteService.getStringValue(
              FireRemoteService.correct_popup_info
            )
          )}
        </div>

        <div className="button-container">
          <Button
            className="modal-button primary"
            onClick={() => props.callbackOk()}
          >
            {parse(
              FireRemoteService.getStringValue(
                props.appStore.tokenBalance !== undefined && props.appStore.tokenBalance > 10
                  ? FireRemoteService.correct_answer_enough_ply_button
                  : FireRemoteService.button_hemen_al
              )
            )}
          </Button>
          <Button
            className="modal-button secondary"
            onClick={() => props.callbackCancel()}
          >
            {parse(
              FireRemoteService.getStringValue(
                FireRemoteService.button_geri_don
              )
            )}
          </Button>
        </div>
      </React.Fragment>
    );
  };

  const renderWrong = (): ReactNode => {
    return (
      <React.Fragment>
        <div className="title-wrapper">
          <img className="icon" src={wrong} alt="wrong" />
          <div className="text">
            {parse(
              FireRemoteService.getStringValue(
                FireRemoteService.wrong_popup_title
              )
            )}
          </div>
        </div>

        <PrizeInfo
          points={FireRemoteService.getStringValue(FireRemoteService.wrong_popup_fb)}
          title={FireRemoteService.getStringValue(FireRemoteService.wrong_popup_kazandin)}
        />

        {props.isExtra && (
          <PrizeInfo
            points={Constants.answerModalYaaniPrizeInfoBoxPrizeExtra2000Points}
            title={Constants.answerModalYaaniPrizeInfoBoxTitleExtra}
          />
        )}

        <div className="note">
          {parse(
            FireRemoteService.getStringValue(
              FireRemoteService.wrong_popup_info
            )
          )}
        </div>

        <div className="button-container">
          <Button
            className="modal-button primary"
            onClick={() => props.callbackOk()}
          >
            {parse(
              FireRemoteService.getStringValue(
                FireRemoteService.button_hemen_al
              )
            )}
          </Button>
          <Button
            className="modal-button secondary"
            onClick={() => props.callbackCancel()}
          >
            {parse(
              FireRemoteService.getStringValue(
                FireRemoteService.button_geri_don
              )
            )}
          </Button>
        </div>
      </React.Fragment>
    );
  };

  return (
    <Modal
      className="answer-modal"
      maskStyle={{ backdropFilter: "blur(8px)" }}
      visible={props.isVisible}
      centered
      closable={false}
      footer={false}
      onCancel={props.callbackCancel}
    >
      <div
        id="answer-modal-body"
        className={`${props.isCorrectAnswer ? "correct" : "wrong"}`}
      >
        {props.isCorrectAnswer ? renderCorrect() : renderWrong()}
      </div>
    </Modal>
  );
};

export default ModalAnswer;
